// extracted by mini-css-extract-plugin
module.exports = {"timer-empty__image-wrapper":"style_timer-empty__image-wrapper__3Qfvz","timer-empty__image":"style_timer-empty__image__1V1c3"};